import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const aggregate = (rows) => {
  const m = {};
  rows.forEach((r) => {
    const k = r.keyword || "(sans mot-clé)";
    const s = (m[k] ||= { keyword: k, forms: 0, calls: 0, validated: 0, unqualified: 0, pending: 0 });
    if (r.type === "form") s.forms += 1; else s.calls += 1;
    s[r.status || "pending"] += 1;
  });
  return Object.values(m)
    .map((s) => {
      const decided = s.validated + s.unqualified;
      return { ...s, rate: decided ? Math.round((s.unqualified / decided) * 100) : null };
    })
    .sort((a, b) => b.unqualified - a.unqualified || b.forms + b.calls - (a.forms + a.calls));
};

export const KeywordTable = ({ rows, onSelect }) => {
  const data = aggregate(rows);
  return (
    <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid="keyword-table">
      <div className="px-4 py-3 border-b border-slate-100">
        <h2 className="font-semibold text-slate-900 text-base">Mots-clés</h2>
        <p className="text-xs text-slate-500">Les pires en premier. Cliquez sur un mot-clé pour voir ses leads.</p>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Mot-clé</TableHead>
            <TableHead className="text-right">Formulaires</TableHead>
            <TableHead className="text-right">Appels</TableHead>
            <TableHead className="text-right">Validés</TableHead>
            <TableHead className="text-right">Pas qualifiés</TableHead>
            <TableHead className="text-right">En attente</TableHead>
            <TableHead className="text-right">% pas qualifiés</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((k) => (
            <TableRow key={k.keyword} className="cursor-pointer hover:bg-slate-50" onClick={() => onSelect(k.keyword)} data-testid={`keyword-row-${k.keyword}`}>
              <TableCell className="font-medium text-slate-900">{k.keyword}</TableCell>
              <TableCell className="text-right">{k.forms}</TableCell>
              <TableCell className="text-right">{k.calls}</TableCell>
              <TableCell className="text-right text-green-700">{k.validated}</TableCell>
              <TableCell className="text-right text-red-600">{k.unqualified}</TableCell>
              <TableCell className="text-right text-amber-600">{k.pending}</TableCell>
              <TableCell className={`text-right font-semibold ${k.rate >= 50 ? "text-red-600" : "text-slate-700"}`}>{k.rate === null ? "—" : `${k.rate}%`}</TableCell>
            </TableRow>
          ))}
          {!data.length && (
            <TableRow><TableCell colSpan={7} className="text-center text-slate-500 py-8">Aucun lead sur cette période</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
